import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=43c6fb9b&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c6fb9b')) {
      api.createRecord('43c6fb9b', component.options)
    } else {
      api.reload('43c6fb9b', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=43c6fb9b&", function () {
      api.rerender('43c6fb9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ct3aCbIB7dap/JS/imageCarousel.vue"
export default component.exports